import {
  Alert,
  Loader,
  Stack,
  Table,
  TableBody,
  TableHeader,
  TableHeaderCell,
  TableRow,
  Text,
} from 'braid-design-system';

import { UserRow } from './components/UserRow/UserRow.tsx';

import { usePermissions } from '#src/hooks/auth.tsx';
import { useOrganizations } from '#src/pages/manage/organizations/OrganizationContext.tsx';

export const UsersList = () => {
  const { users, loading, error } = useOrganizations();

  const { permissions } = usePermissions();
  const hasWriteAccess = permissions.includes('mutate:users');

  if (loading) {
    return <Loader />;
  }

  if (error) {
    return (
      <Alert tone="critical">
        <Stack space="small">
          <Text>We couldn’t load the user list.</Text>
          <Text size="small">{error}</Text>
        </Stack>
      </Alert>
    );
  }

  return (
    <Table label="Users">
      <TableHeader>
        <TableRow>
          <TableHeaderCell>
            <Text>User</Text>
          </TableHeaderCell>

          <TableHeaderCell>
            <Text>Role</Text>
          </TableHeaderCell>

          <TableHeaderCell>
            <Text>Added</Text>
          </TableHeaderCell>

          {hasWriteAccess ? (
            <TableHeaderCell>
              {
                /* Actions */
                null
              }
            </TableHeaderCell>
          ) : null}
        </TableRow>
      </TableHeader>

      <TableBody>
        {users.map((user) => (
          <UserRow
            key={user.emailAddress}
            user={user}
            hasWriteAccess={hasWriteAccess}
            isImpersonating={user.impersonating}
          />
        ))}
      </TableBody>
    </Table>
  );
};
